import { render, staticRenderFns } from "./OrdiniFornitori.vue?vue&type=template&id=6db044bc&"
import script from "./OrdiniFornitori.vue?vue&type=script&lang=js&"
export * from "./OrdiniFornitori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports